import { AxiosResponse } from "axios";
import { api } from "./axios";

export type ChatUser = {
  userId: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  verified: boolean;
  lastMessageText: string;
  lastMessageAt: string;
  profilePicture: string | undefined;
};

export const ALL_USERS = "all-users";
export const getAllUsers = (
  userId: number,
): Promise<AxiosResponse<ChatUser[]>> => {
  return api.get("/user/chatListOf", { params: { userId } });
};

export const updateProfilePicture = (
  file: string | Blob,
  userId: number,
): Promise<AxiosResponse<string>> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("userId", userId.toString());
  return api.post("/user/profilePicture", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
